import { Flex, Text } from '@mantine/core';

import type { CandidatePickVacancyMeta } from '../../types';

export const CandidatePickVacancyRow = ({
  vacancyTitle,
  vacantPlaces,
}: CandidatePickVacancyMeta) => {
  return (
    <Flex
      align='flex-end'
      justify='space-between'
      gap={16}
      wrap='wrap'
      style={{ flexShrink: 0 }}
    >
      <Flex gap={4} wrap='wrap' align='baseline'>
        <Text
          size='md'
          fw={600}
          c='tertiary.7'
          style={{ letterSpacing: '-0.02em', lineHeight: '18px' }}
        >
          Вакансия:
        </Text>
        <Text
          size='lg'
          fw={600}
          c='primary.7'
          style={{ letterSpacing: '-0.04em', lineHeight: '24px' }}
        >
          {vacancyTitle}
        </Text>
      </Flex>

      <Flex align='baseline' gap={4}>
        <Text
          size='md'
          fw={600}
          c='tertiary.7'
          style={{ letterSpacing: '-0.02em', lineHeight: '18px' }}
        >
          Вакантных мест:
        </Text>
        <Text
          size='md'
          fw={600}
          c='tertiary.7'
          style={{ letterSpacing: '-0.02em', lineHeight: '18px' }}
        >
          {vacantPlaces}
        </Text>
      </Flex>
    </Flex>
  );
};
